import { useEffect, useState } from 'react';
import { listZonesCached } from '../services/zones';

const IDLE = { status: 'idle', zones: [] };
const LOADING = { status: 'loading', zones: [] };

/**
 * ТЗ V5 №6: текущий каталог зон камеры для наложения на кадр. Каталог всегда
 * той камеры, которой принадлежит кадр: пока грузится новая камера, зоны
 * предыдущей не показываются. Ошибка — status 'error', кадр при этом
 * остаётся доступен.
 */
const useCameraZones = (cameraId) => {
  const [state, setState] = useState({ cameraId: null, ...IDLE });

  useEffect(() => {
    if (cameraId == null || cameraId === '') return undefined;
    let cancelled = false;
    setState({ cameraId, ...LOADING });
    // Синхронный сбой запроса — та же ошибка зон, кадр не ломается.
    Promise.resolve()
      .then(() => listZonesCached(cameraId))
      .then((data) => {
        if (!cancelled) setState({ cameraId, status: 'ready', zones: Array.isArray(data?.items) ? data.items : [] });
      })
      .catch(() => {
        if (!cancelled) setState({ cameraId, status: 'error', zones: [] });
      });
    return () => { cancelled = true; };
  }, [cameraId]);

  if (cameraId == null || cameraId === '') return IDLE;
  if (state.cameraId !== cameraId) return LOADING;
  return { status: state.status, zones: state.zones };
};

export default useCameraZones;
